import { Box, useTheme } from "@mui/material"
import { useState } from "react";

import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import { tokens } from "../../../theme";
import SHModal from "../../theme/Modal/SHModal";
import Shbutton from "../../theme/buttons/Shbutton";
import Subheading from "../../theme/text/Subheading";
import Text from "../../theme/text/Text";
import ButtonGroup from "../../theme/buttons/ButtonGroup";
import { useTranslation } from "react-i18next";
import { useAddInvoiceCategoryMutation } from "../../../newapi/financial/invoiceCategorySlice";
import { showToastMessagePostRequest, showToastMessageRequestError } from "../../../utils/toasts";
import * as yup from "yup";
import ShValidatedInput from "../../theme/inputs/ShValidatedInput";
import ShValidatedInputDropdown from "../../theme/dropdowns/ShValidatedInputDropdown";
import { yupRequired } from "../../../utils/validation";
import { useGetEnumsQuery } from "../../../newapi/global/generalApiSlice";

// An empty minimum means the category does not take part in the automatic category check
// for that invoicing frequency, so it is sent as null instead of 0
const toMinimum = (value) => value === "" || value === null ? null : parseInt(value);

const MAddInvoiceCategory = (props) => {
    const {t} = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    const [addInvoiceCategory,{isLoading}] = useAddInvoiceCategoryMutation();

    const [invoiceCategoryInfo, setInvoiceCategoryInfo] = useState({
        name: "",
        minimumOrdersWeekly: "",
        minimumOrdersSemiMonth: "",
        minimumOrdersMonth: "",
    });

    const handleClose = () => {
      setInvoiceCategoryInfo({
          name: "",
          minimumOrdersWeekly: "",
          minimumOrdersSemiMonth: "",
          minimumOrdersMonth: "",
      });
      props.handleClose();
  }

    const [fieldErrors, setFieldErrors] = useState({});

    const rules = {
        name: yupRequired('name', t)
    };
    
    const schema = yup.object().shape(rules);
    
    const SaveInvoiceCategoryInfo = async (invoiceCategoryInfo, props) => {
        try {
            if (isLoading) return;

            setFieldErrors({});
            await schema.validate(invoiceCategoryInfo, { abortEarly: false });
            const data = await addInvoiceCategory({
                ...invoiceCategoryInfo,
                minimumOrdersWeekly: toMinimum(invoiceCategoryInfo.minimumOrdersWeekly),
                minimumOrdersSemiMonth: toMinimum(invoiceCategoryInfo.minimumOrdersSemiMonth),
                minimumOrdersMonth: toMinimum(invoiceCategoryInfo.minimumOrdersMonth),
            }).unwrap()
            showToastMessagePostRequest(t, data);

            handleClose();
        } catch (err) {
            if (err.name === 'ValidationError') {
                // Create an errors object where keys are field names and values are error messages
                const errors = err.inner.reduce((acc, currentError) => ({
                  ...acc,
                  [currentError.path]: currentError.message
                }), {});
          
                // Set the validation errors in the state
                setFieldErrors(errors);
              } else {
                // Handle other errors, such as network errors
                showToastMessageRequestError(t("create_failed"), t, err);
              }
        }
    };
    let isStandAlone = false;
    if (window.matchMedia('(display-mode: standalone)').matches) {
        isStandAlone = true;
    }

    const handleChange = (key, value) => {
        setInvoiceCategoryInfo({
          ...invoiceCategoryInfo,
          [key]: value
        });
        setFieldErrors({
            ...fieldErrors,
            [key]: ''
          });
      };

    return(
        <SHModal
            open={props.open}
            onClose={handleClose}
        >
            <Box 
                sx={{
                    textAlign:"center",
                    paddingY:4,
                    paddingX:5,
                    display:"flex",
                    flexDirection:"column",
                    gap:1
                }}>
                <Subheading>{t("add_category")}</Subheading>
            </Box>

            <Box
                sx={{
                    background:theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0],
                    padding:3,
                    borderTopLeftRadius:16,
                    borderTopRightRadius:16,
                    display:"flex",
                    flexDirection:"column",
                    gap:2
                }}
            >
                <Box 
                    sx={{
                        width:1,
                        display:"flex",
                        alignItems:"center",
                        justifyContent:"space-between",
                        gap:7,
                        alignItems:"flex-start"
                    }}
                >
                    
                    <Box
                        sx={{
                            minWidth:210,
                            pt:1,
                        }}
                    >
                        <Text>{t("name")}</Text>
                    </Box>
                    
                    
                    <ShValidatedInput
                            name="name"
                            value={invoiceCategoryInfo.name}
                            onChange={handleChange}
                            error={fieldErrors.name}
                        />
                            
                </Box>
                <Box 
                    sx={{
                        width:1,
                        display:"flex",
                        alignItems:"center",
                        justifyContent:"space-between",
                        gap:7,
                        alignItems:"flex-start"
                    }}
                >
                    
                    <Box
                        sx={{
                            minWidth:210,
                            pt:1,
                        }}
                    >
                        <Text>{t("minimum_orders_weekly")}</Text>
                    </Box>
                    
                    
                    <ShValidatedInput
                            name="minimumOrdersWeekly"
                            type="number"
                            value={invoiceCategoryInfo.minimumOrdersWeekly}
                            onChange={handleChange}
                            error={fieldErrors.minimumOrdersWeekly}
                        />
                            
                </Box>
                <Box 
                    sx={{
                        width:1,
                        display:"flex",
                        alignItems:"center",
                        justifyContent:"space-between",
                        gap:7,
                        alignItems:"flex-start"
                    }}
                >
                    
                    <Box
                        sx={{
                            minWidth:210,
                            pt:1,
                        }}
                    >
                        <Text>{t("minimum_orders_semi_month")}</Text>
                    </Box>
                    
                    
                    <ShValidatedInput
                            name="minimumOrdersSemiMonth"
                            type="number"
                            value={invoiceCategoryInfo.minimumOrdersSemiMonth}
                            onChange={handleChange}
                            error={fieldErrors.minimumOrdersSemiMonth}
                        />
                            
                </Box>
                <Box 
                    sx={{
                        width:1,
                        display:"flex",
                        alignItems:"center",
                        justifyContent:"space-between",
                        gap:7,
                        alignItems:"flex-start"
                    }}
                >
                    
                    <Box
                        sx={{
                            minWidth:210,
                            pt:1,
                        }}
                    >
                        <Text>{t("minimum_orders_month")}</Text>
                    </Box>
                    
                    
                    <ShValidatedInput
                            name="minimumOrdersMonth"
                            type="number"
                            value={invoiceCategoryInfo.minimumOrdersMonth}
                            onChange={handleChange}
                            error={fieldErrors.minimumOrdersMonth}
                        />
                            
                </Box>
            </Box>
            <Box
                component="footer"
                sx={{
                    
                    display:"block",
                    width:1,
                    paddingBottom: isStandAlone ? "32px" : "16px",
                    display:"flex",
                    alignItems:"center",
                    paddingRight:3,
                    zIndex:1058,
                    position:"relative",
                    paddingTop:2,
                    background:`${theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0]}`,
                    borderBottomLeftRadius:24,
                    borderBottomRightRadius:24,
                    justifyContent:"space-between",
                    "@media screen and (max-width: 47.9375em)" : {
                        paddingRight:0,
                    }
                }}
            >
                <Shbutton isCancel={true} className={"always-visible"} onClick={handleClose} color="primary" variant="text" startIcon={<ArrowRightAltIcon/>}>{t("cancel")}</Shbutton>
                <ButtonGroup version={2}>
                    <Shbutton isLoading={isLoading} className={"group-btn"} color={"green"}
                    variant="contained" 
                    onClick={() => SaveInvoiceCategoryInfo(invoiceCategoryInfo, props)}
                    >{t("add")}</Shbutton>
                </ButtonGroup>
            </Box>
        </SHModal>
    )
}

export default MAddInvoiceCategory;
